<template>
  <el-dialog
      :close-on-click-modal="false"
      title="设置应付运费"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
          @sub="sub"
          :noSubBtn="true"
          ref="customForm"
          :formData="formData"
          label-width="160px"
      >
        <div slot="fillFreightDouble">
            <el-input class="inputBox" v-model="formData.fillFreightDouble" placeholder="请输入" oninput="value=value.replace('.','$#$').replace(/\./g, '').replace('$#$', '.').replace(/[^\d.]/g, '').replace(/^\./g, '').replace( /([0-9]+\.[0-9]{2})[0-9]*/,'$1')">
              <span slot="suffix" class="inputSlotText">元</span>
            </el-input>
        </div>
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="customFormPost" :loading="subLoading || getDetailLoading">确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  setFillFreight,
} from 'api/operate';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      originData: {},
      formData: {
        form: [
          {
            label: '应付运费',
            value: 'fillFreightDouble',
            slot: true,
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    async show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.originData = item;
      this.getDetailLoading = true;
      this.getDetailLoading = false;
      this.$set(this.formData, 'fillFreightDouble', item.fillFreightDouble);
      this.$nextTick(() => {
        this.$refs.customForm.setVal('fillFreightDouble', this.originData.fillFreightDouble);
      });
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await setFillFreight({
        orderId: this.originData.orderId,
        fillFreight: this.formData.fillFreightDouble,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        this.$message({
          type: 'success',
          message: '保存成功',
        });
        this.$emit('sub');
      }
    },
  },
};
</script>

<style>
</style>
